export enum RecipientType {
  NEWSLETTER = "NEWSLETTER",
  RECOMMENDATION = "RECOMMENDATION",
  ENERGY_PRICES = "ENERGY_PRICES",
  GAS_PRICES = "GAS_PRICES",
  RECOMMENDATION_CONFIRMATION = "RECOMMENDATION_CONFIRMATION"
}
